import type { SeoService } from './core';

const GLOBAL_DESCRIPTION_COPY: Record<SeoService, string> = {
  חתונה:
    'די ג׳יי מומלץ לחתונה עם מעל 15 שנות ניסיון, התאמה אישית ותכנון מוזיקלי שנבנה לזוג, קריאת קהל חדה ויצירת אווירה מדויקת לכל רגע בחתונה.',
  חינה:
    'די ג׳יי מומלץ לחינה עם מעל 15 שנות ניסיון, מוזיקה לכל העדות ושילוב מושלם של מסורת ומודרניות לחגיגה שמחה ומיוחדת.',
  'בר-מצווה':
    'די ג׳יי מומלץ לבר/בת מצווה עם מעל 15 שנות ניסיון, מוזיקה שמותאמת לצעירים ולמבוגרים, קריאת קהל חדה וניהול מוזיקלי מדויק לכל שלב באירוע.',
  אירוע:
    'די ג׳יי מומלץ לאירועים עם מעל 15 שנות ניסיון, שליטה במגוון רחב של סגנונות מוזיקליים, התאמה מדויקת לקהל ובניית אווירה שמתאימה לכל אירוע.',
};

const LOCAL_DESCRIPTION_COPY: Record<SeoService, (locationLabel: string) => string> = {
  חתונה: (locationLabel) =>
    `די ג׳יי מומלץ לחתונה ב${locationLabel} עם מעל 15 שנות ניסיון, תכנון מוזיקלי אישי, קריאת קהל חדה, מיקסים מדויקים ויצירת אווירה מדויקת לכל רגע בחתונה.`,
  חינה: (locationLabel) =>
    `די ג׳יי מומלץ לחינה ב${locationLabel} עם מעל 15 שנות ניסיון, מוזיקה לכל העדות ושילוב מושלם של מסורת ומודרניות לחגיגה שמחה, צבעונית ומיוחדת.`,
  'בר-מצווה': (locationLabel) =>
    `די ג׳יי מומלץ לבר/בת מצווה ב${locationLabel} עם מעל 15 שנות ניסיון, מוזיקה שמחברת נוער ומשפחה, קריאת קהל חדה וניהול מוזיקלי מדויק לאירוע שמח ומרגש.`,
  אירוע: (locationLabel) =>
    `די ג׳יי מומלץ לאירוע ב${locationLabel} עם מעל 15 שנות ניסיון, תכנון מוזיקלי והתאמה מדויקת לקהל, שליטה במגוון רחב של סגנונות ובניית אווירה לאירוע שמח ומדויק.`,
};

export const HOME_SEO_DESCRIPTION =
  'די ג׳יי מומלץ לאירועים עם מעל 15 שנות ניסיון, אלפי אירועים ועשור די ג׳יי הבית של מועדון הפורום, מוזיקה בהתאמה אישית, קריאת קהל חדה ובניית האווירה לכל רגע באירוע.';

export function buildGlobalSeoDescription(service: SeoService) {
  return GLOBAL_DESCRIPTION_COPY[service];
}

export function buildLocalSeoDescription(service: SeoService, locationLabel: string) {
  const loc = String(locationLabel || '').trim();
  if (!loc) return buildGlobalSeoDescription(service);
  return LOCAL_DESCRIPTION_COPY[service](loc);
}
